
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/ev-calculator",
      function () {
        return require("private-next-pages/evcharging/ev-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/ev-calculator"])
      });
    }
  